import { useState } from "react";
import { useTranslation } from "react-i18next";
import CreatorSkeleton from "src/components/NewComponents/Skeletons/Creator";

import { TextPrimaryButton } from "../../../Default/LekUI/Button";

const ClearAll = (props) => {
	const { t } = useTranslation();

	if (!props.count) {
		return null;
	}

	return (
		<div className="flex items-center justify-between mb-16">
			<p className="m-0">
				{t("defaultsText.filter")} (<span>{props.count}</span>)
			</p>
			{props.count > 0 && (
				<TextPrimaryButton
					className="p-2"
					onClick={props.onClear}
				>{`X ${t("commands.clear")}`}</TextPrimaryButton>
			)}
		</div>
	);
};

function Filters(props) {
	// defaultExpanded: id akordeonu otwartego na starcie (np. gdy filtr jest tylko jeden)
	const [expanded, setExpanded] = useState(props.defaultExpanded ?? null);

	const handleChange = (id) => {
		setExpanded(expanded === id ? null : id);
	};

	if (props.isLoading) {
		return <CreatorSkeleton />;
	}

	return (
		<div>
			<div>
				<ClearAll count={props.filtersCount} onClear={props.clearAll} />
				{props.renderFilters(expanded, handleChange)}
				{props.renderExtraFilters?.(expanded, handleChange)}
			</div>
			{props.children}
		</div>
	);
}

export default Filters;
